angular.module('controllers').controller('driverNotificationController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location) {

		$rootScope.path = '/driver-notification';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'driver_notification';
		$scope.pathTemplate = 'distribution/drivernotifications';
		$scope.title = 'Notificari/Alerte soferi';
		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'created_at';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'driver_name':{'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
			'driver_notification':{'label':'Notificare', 'filter':0},
			'driver_notification_type':{'label': 'Tip', 'filter': 1, 'filterType': 'select'},
			'created_at':{'label': 'Data', 'filter': 0, 'filterType': 'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.columns.driver_notification_type.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'Notificare ordine comenzi'},
			{'id':2, 'value' : 'Notificare stationare'},
			{'id':3, 'value' : 'Notificare deconectare'}
		];
		$scope.search.order = 'desc';
		$scope.additionals['content_type'] = 'form-urlencoded';

		/* autocomplete */
		$scope.additionals['selectedItemDriver'] = null;
		$scope.additionals['drivers'] = [];

		$scope.additionals['getDrivers'] = function(driver_name) {
			return Crud.get($scope.path + '/getDrivers?driver_name='+driver_name)
				.then(function (data) {
					$scope.additionals['drivers'] = data.data['drivers'];
					return data.data['drivers'];
				});
		}

		$scope.additionals['changeFieldDriver'] = function(model, index) {
			if (!angular.isUndefined(index)) {
				if ($scope.additionals['selectedItemDriver'][index] != null && $scope.additionals['selectedItemDriver'][index] != 'null') {
					$scope.modelsData[index]['driver_id'] = $scope.additionals['selectedItemDriver'][index]['id'];
				}
			} else {
				if ($scope.additionals['selectedItemDriver'] != null && $scope.additionals['selectedItemDriver'] != 'null') {
					$scope.modelData['driver_id'] = $scope.additionals['selectedItemDriver']['id'];
				}
			}
		}
		/* end autocomplete */

		$scope.additionals['function'] = function (ev, data) {
			if($scope.action == 'updatemultiple') {
				$scope.additionals['selectedItemDriver'] = {};
			} else {
				$scope.additionals['selectedItemDriver'] = null;
			}
		}

		$scope.additionals['functionResult']= function(ev, data) {
			/*if($scope.action == 'updatemultiple') {
				angular.forEach($scope.modelsData, function (item, key) {
					item['driver_notification'] = $scope.additionals['truncate'](item['driver_notification'], 500);
				});
			} else {
				$scope.modelData['driver_notification'] = $scope.additionals['truncate']($scope.modelData['driver_notification'], 500);
			}*/
		}

		$scope.maxDate = new Date();
		$scope.minDate = '2010-01-01';
		var current_init_date = new Date();
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;


	}]
);




